import { useEffect } from "react";

const usePreventInspection = () => {
  useEffect(() => {
    // 1. Disable Right Click (Context Menu)
    const disableRightClick = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", disableRightClick);

    // 2. Disable Keyboard Shortcuts (F12, Ctrl/Cmd + Shift + I/J/C, Ctrl/Cmd + U)
    const disableKeyShortcuts = (e) => {
      // F12 key
      if (e.keyCode === 123) {
        e.preventDefault();
      }
      // Developer Tools shortcuts (Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C)
      if (
        (e.ctrlKey || e.metaKey) &&
        e.shiftKey &&
        (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)
      ) {
        e.preventDefault();
      }
      // View Source (Ctrl/Cmd + U)
      if ((e.ctrlKey || e.metaKey) && e.keyCode === 85) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", disableKeyShortcuts);

    // Cleanup function: remove listeners when the component unmounts
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeyShortcuts);
    };
  }, []);
};

export default usePreventInspection;
